<template>
  <div id="app" :data-visitor="visitor">
    <template v-if="disLayout">
      <router-view></router-view>
    </template>
    <template v-else>
      <template v-if="layout == 'pc'">
        <tg-app>
          <router-view></router-view>
        </tg-app>
      </template>
      <template v-else>
        <tg-mobile>
          <router-view></router-view>
        </tg-mobile>
      </template>
    </template>
    <tg-service-btn v-if="showService"></tg-service-btn>
    <tg-dialog
      :showIcon="false"
      :title="$t('component.service.24h')"
      :visible.sync="showServiceIsFix"
      append-to-body
      top="20vh"
      width="40%"
    >
      <el-row type="flex" justify="center" align="middle">
        <span
          style="text-align: center; font-size: 36px; word-break: break-word"
          class="text-red"
          v-html="$t('component.dialog.customer_service.fix')"
        >
        </span>
      </el-row>
    </tg-dialog>
    <tg-customer-service-dialog ref="serviceDialog" :src="serviceUrl">
    </tg-customer-service-dialog>
    <span
      v-loading.fullscreen="fullscreenLoading"
      element-loading-text="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></span>
  </div>
</template>

<script>
import TgApp from "@/layout/TgApp";
import TgMobile from "@/layout/TgMobile";
import TgServiceBtn from "@/components/button/TgServiceBtn.vue";
import TgDialog from "@/components/dialog/TgDialog";
import TgCustomerServiceDialog from "@/components/dialog/TgCustomerServiceDialog";
// import Cookies from "js-cookie";

let __app_last_ticket = 0;
// 分
const __fetch_interval = 15;

// import TgMobileMenu from "@/layout/TgMobileMenu";
export default {
  name: "App",
  components: {
    TgApp,
    TgMobile,
    TgServiceBtn,
    TgDialog,
    TgCustomerServiceDialog,
  },
  data() {
    return {
      audio: [],
    };
  },
  computed: {
    toolDialogTitle() {
      return this.$store.state.toolDialogTitle;
    },
    toolDialogVisible() {
      return this.$store.state.toolDialogVisible;
    },

    disLayout() {
      if (this.$route.meta) {
        return this.$route.meta.layout == false;
      }
      return false;
    },
    showService() {
      let excepts = ["limit", "service"];
      return (
        excepts.findIndex((x) => x == this.$route.name) == -1 &&
        this.$store.state.service?.serviceChannel.length != 0
      );
    },
    fullscreenLoading() {
      return this.$store.state.fullscreenLoading;
    },
    serviceUrl() {
      return this.$store.state.service.serviceUrl;
    },
    showServiceIframe() {
      return this.$store.state.service.showServiceIframe;
    },
    showServiceIsFix: {
      get() {
        return this.$store.state.service.serviceIsFix;
      },
      set(val) {
        this.$store.commit("service/update", { serviceIsFix: val });
      },
    },
    currentLang() {
      return this.$store.state.app.lang.key;
    },
    currentMerchantCode() {
      return this.$store.state.service.merchantCode;
    },
    visitor() {
      return "auth" in this.$route.meta && this.$route.meta.auth == false
        ? 1
        : 0;
    },
  },
  props: {
    layout: String,
  },
  created() {
    if (this.$store.state.app.lang.message == null) {
      if (this.$route.name != "init") {
        this.$router.push({ name: "init", params: { from: this.$route } });
      }
    }

    setInterval(() => {
      __app_last_ticket += 60000;

      if (this.$route.meta.layout !== false) {
        // if(this.$user.name){
        this.$store.dispatch("app/fetch");
        // }
      }

      if (__app_last_ticket >= 60000 * __fetch_interval) {
        __app_last_ticket = 0;
        this.$store.dispatch("service/fetch");
        this.$store.dispatch("thirdParty/fetch");
      }
    }, 60000);
  },
  mounted() {
    // add theme dark to body
    if (this.currentMerchantCode == "AA008") {
      document.querySelector("body").classList.add("theme-dark");
    }
    document.querySelector("body").setAttribute("data-lang", this.currentLang);
    this.$store.dispatch("app/fetch");
  },
  methods: {
    handleToolDialogClose() {
      this.$store.commit("TOOL_DIALOG_STATUS", false);
    },
  },
  watch: {
    showServiceIframe(bool) {
      if (bool) {
        this.$refs.serviceDialog.showDialog();
      }
    },
    currentLang(val) {
      document.querySelector("body").setAttribute("data-lang", val);
    },
    currentMerchantCode(val) {
      if (val == "AA008") {
        document.querySelector("body").classList.add("theme-dark");
      }
    },
  },
};
</script>
